/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetPaymentRequestDetail200ResponseApprovalStepsInner } from './get-payment-request-detail200-response-approval-steps-inner';
// May contain unused imports in some cases
// @ts-ignore
import { GetPaymentRequestDetail200ResponseCommentsInner } from './get-payment-request-detail200-response-comments-inner';
// May contain unused imports in some cases
// @ts-ignore
import { GetPaymentRequestDetail200ResponseDeal } from './get-payment-request-detail200-response-deal';
// May contain unused imports in some cases
// @ts-ignore
import { GetPaymentRequestDetail200ResponseEvidencesInner } from './get-payment-request-detail200-response-evidences-inner';
// May contain unused imports in some cases
// @ts-ignore
import { GetPaymentRequestDetail200ResponseRequestor } from './get-payment-request-detail200-response-requestor';
// May contain unused imports in some cases
// @ts-ignore
import { GetPaymentRequestDetail200ResponseSupplier } from './get-payment-request-detail200-response-supplier';

/**
 * 
 * @export
 * @interface GetPaymentRequestDetail200Response
 */
export interface GetPaymentRequestDetail200Response {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200Response
     */
    'serialNumber': string;
    /**
     * 
     * @type {GetPaymentRequestDetail200ResponseSupplier}
     * @memberof GetPaymentRequestDetail200Response
     */
    'supplier': GetPaymentRequestDetail200ResponseSupplier;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200Response
     */
    'dueDate': string;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestDetail200Response
     */
    'totalAmount': number;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200Response
     */
    'transferFeeResponsibility': GetPaymentRequestDetail200ResponseTransferFeeResponsibilityEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200Response
     */
    'memo': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200Response
     */
    'withholdingCalculatingMethod': GetPaymentRequestDetail200ResponseWithholdingCalculatingMethodEnum;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestDetail200Response
     */
    'withholdingAmount': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200Response
     */
    'status': GetPaymentRequestDetail200ResponseStatusEnum;
    /**
     * 
     * @type {GetPaymentRequestDetail200ResponseRequestor}
     * @memberof GetPaymentRequestDetail200Response
     */
    'requestor': GetPaymentRequestDetail200ResponseRequestor;
    /**
     * requestorName is the name of the requesting user at the time this PaymentRequest was requested. The free word search targets the name of requesting user, but it is the requestorName that is targeted, not the name of the user at the time of the search. Use requestor.name if you want to know what is the name at present of the user.
     * @type {string}
     * @memberof GetPaymentRequestDetail200Response
     */
    'requestorName': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200Response
     */
    'requestedAt': string;
    /**
     * If bank transfer data has already been created, return the ID. Otherwise, null.
     * @type {string}
     * @memberof GetPaymentRequestDetail200Response
     */
    'bankTransferId': string | null;
    /**
     * One or more evidences are associated with a payment request, and one of them is the invoice that motivated creating the payment request. invoiceEvidenceId is the ID of the evidence selected as the invoice among the evidences array.
     * @type {string}
     * @memberof GetPaymentRequestDetail200Response
     */
    'invoiceEvidenceId': string;
    /**
     * 
     * @type {Array<GetPaymentRequestDetail200ResponseEvidencesInner>}
     * @memberof GetPaymentRequestDetail200Response
     */
    'evidences': Array<GetPaymentRequestDetail200ResponseEvidencesInner>;
    /**
     * 
     * @type {GetPaymentRequestDetail200ResponseDeal}
     * @memberof GetPaymentRequestDetail200Response
     */
    'deal': GetPaymentRequestDetail200ResponseDeal | null;
    /**
     * 
     * @type {Array<GetPaymentRequestDetail200ResponseCommentsInner>}
     * @memberof GetPaymentRequestDetail200Response
     */
    'comments': Array<GetPaymentRequestDetail200ResponseCommentsInner>;
    /**
     * 
     * @type {Array<GetPaymentRequestDetail200ResponseApprovalStepsInner>}
     * @memberof GetPaymentRequestDetail200Response
     */
    'approvalSteps': Array<GetPaymentRequestDetail200ResponseApprovalStepsInner>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetPaymentRequestDetail200Response
     */
    'deletableEvidenceIds': Array<string>;
}

export const GetPaymentRequestDetail200ResponseTransferFeeResponsibilityEnum = {
    self: 'SELF',
    supplier: 'SUPPLIER'
} as const;

export type GetPaymentRequestDetail200ResponseTransferFeeResponsibilityEnum = typeof GetPaymentRequestDetail200ResponseTransferFeeResponsibilityEnum[keyof typeof GetPaymentRequestDetail200ResponseTransferFeeResponsibilityEnum];
export const GetPaymentRequestDetail200ResponseWithholdingCalculatingMethodEnum = {
    none: 'NONE',
    manuscriptOrLecture: 'MANUSCRIPT_OR_LECTURE',
    lawyerOrCpa: 'LAWYER_OR_CPA',
    judicialScrivener: 'JUDICIAL_SCRIVENER',
    other: 'OTHER'
} as const;

export type GetPaymentRequestDetail200ResponseWithholdingCalculatingMethodEnum = typeof GetPaymentRequestDetail200ResponseWithholdingCalculatingMethodEnum[keyof typeof GetPaymentRequestDetail200ResponseWithholdingCalculatingMethodEnum];
export const GetPaymentRequestDetail200ResponseStatusEnum = {
    pendingWorkflowCompletion: 'PENDING_WORKFLOW_COMPLETION',
    canceled: 'CANCELED',
    payable: 'PAYABLE',
    attachedToBankTransfer: 'ATTACHED_TO_BANK_TRANSFER',
    deactivated: 'DEACTIVATED'
} as const;

export type GetPaymentRequestDetail200ResponseStatusEnum = typeof GetPaymentRequestDetail200ResponseStatusEnum[keyof typeof GetPaymentRequestDetail200ResponseStatusEnum];


